module.exports = __webpack_public_path__ + "static/media/dpl-logo-new.f18cf8d3.png";